<ng-container *ngIf="(results | async) as contracts">
  <table [ngClass]="{ 'no-margin': dataPageVersion }">
    <thead>
      <tr>
        <th>
          Specialty
          <p>State | Date</p>
        </th>
        <th>
          <span>Guaranteed Comp</span>
          <lib-sort *ngIf="!dataPageVersion"
            class="sort"
            [sortOrder]="sortBy === 'GuaranteedCompensation' ? sortOrder : null" 
            (sortUpdated)="sortChangeEvent($event, 'GuaranteedCompensation')">
          </lib-sort>
          <p>Position Type</p>
        </th>
        <th>
          <span>Signing Bonus</span>
          <lib-sort *ngIf="!dataPageVersion"
            class="sort"
            [sortOrder]="sortBy === 'SigningBonus' ? sortOrder : null"
            (sortUpdated)="sortChangeEvent($event, 'SigningBonus')">
          </lib-sort>
          <p>Relocation Bonus</p>
        </th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let contract of contracts.items; let i = index">
        <tr *ngIf="!dataPageVersion && showAd && i === 2 && contracts.pageNumber === 1">
          <td colspan="3">
            <lib-rdata-upgrade-ad></lib-rdata-upgrade-ad>
          </td>
        </tr>
        <tr [ngClass]="{'clickable': clickableResults}" (click)="showDetails($event, contract.id)">
          <td>
            {{contract.specialty}}
            <p [ngClass]="{'verified': contract.verified}">
              {{contract.stateAbbreviation ? (contract.stateAbbreviation | stateAbbrToName) : contract.region}} | {{contract.contractStartDate | slice:0:10 | date: 'MM/yyyy'}}
            </p>
          </td>
          <td>
            {{contract.guaranteedCompensation | rdata:'guaranteedCompensation'}}
            <lib-rdata-badge *ngIf="contract.negotiatedGuaranteedCompensationDifference" (click)="$event.stopPropagation();">
              {{contract.negotiatedGuaranteedCompensationDifference | abbreviateNumber}}
              <span tooltip>{{contract.negotiatedGuaranteedCompensationDifference | abbreviateNumber}} negotiated increase.</span>
            </lib-rdata-badge>
            <p>
              {{ contract.positionType | rdata:'positionType' }}
            </p>
          </td>
          <td>
            <div class="view-more">
              <div>
                {{contract.signingBonus | rdata:'signingBonus'}}
                <lib-rdata-badge *ngIf="contract.negotiatedSigningBonusDifference" (click)="$event.stopPropagation();">
                  {{contract.negotiatedSigningBonusDifference | abbreviateNumber }}
                  <span tooltip>{{contract.negotiatedSigningBonusDifference | abbreviateNumber}} negotiated increase.</span>
                </lib-rdata-badge>
                <p>{{contract.relocationBonus | rdata:'relocationBonus'}}</p>
              </div>
              <button *ngIf="clickableResults"
                class="details-button"
                type="button"
                (click)="showDetails($event, contract.id)">
                <img src="/assets/icons/rdata/chevron-left-solid.svg" alt="View details" width="8" height="13"/>
              </button>
            </div>
          </td>
        </tr>
      </ng-container>

      <tr *ngIf="contracts.items && contracts.items?.length === 0">
        <td class="not-found" colspan="3">No contracts found. Please adjust your filters and try again.</td>
      </tr>
      <tr *ngIf="!dataPageVersion && showAd && contracts.items && contracts.items?.length <= 2" class="upgrade-wrapper">
        <td colspan="3">
          <lib-rdata-upgrade-ad></lib-rdata-upgrade-ad>
        </td>
      </tr>
    </tbody>
  </table>


  <ng-container *ngIf="!dataPageVersion && !hidePagination">
    <lib-pagination *ngIf="contracts.items && contracts.items?.length > 0"
      [lightStyle]="true"
      [totalCount]="contracts.totalCount"
      [pageSize]="contracts.pageSize"
      [currentPage]="contracts.pageNumber"
      (newPageSelected)="pageChangeEvent($event)"
    ></lib-pagination>
  </ng-container>
</ng-container>